module app {
    "use strict";
    import IScope = angular.IScope;
    import IRootScopeService = angular.IRootScopeService;
    import ISidenavService = angular.material.ISidenavService;
    import InformacaoService = app.toolbar.InformacaoService;

    export class MainController {

        /** @ngInject **/
        public constructor($scope: IScope,
                    $rootScope: IRootScopeService,
                    private $mdSidenav: ISidenavService,
                    private informacaoService: InformacaoService) {
            $scope.$on("$viewContentAnimationEnded", function(event) {
                if (event.targetScope.$id === $scope.$id) {
                    $rootScope.$broadcast("msSplashScreen::remove");
                }
            });
        }

        public openSavedSearchs(): void {
            this.$mdSidenav("info-viewer").open();
        }

        public getConsulta() {
            return this.informacaoService.getConsulta();
        }

        public getInformacao() {
            return this.informacaoService.getInformacao();
        }

        public isInfoNavOpen() {
            return this.$mdSidenav("info-viewer").isOpen();
        }

    }

    angular
        .module("app")
        .controller("app.MainController", MainController);
}
